import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faTachometerAlt,
    faInfo,
    faWallet,
    faSignOutAlt,
    faTools,
    faUserCog,
} from '@fortawesome/free-solid-svg-icons';
import { Link, useNavigate } from "react-router-dom";

const Sidebar = ({ show }) => {
    const [displaySidebar, setDisplaySidebar] = useState(false);
    const [openDropdown, setOpenDropdown] = useState(true);
    const [isAdmin, setIsAdmin] = useState(false);

    const toggleDropdown = (id) => {
        setOpenDropdown(openDropdown === id ? null : id);
    };

    useEffect(() => {
        if (show) {
            setDisplaySidebar(true);
        }
    }, [show]);

    useEffect(() => {
        const storedAuthor = localStorage.getItem('author');
        if (storedAuthor) {
            const author = JSON.parse(storedAuthor);
            setIsAdmin(author.is_admin === 1);
        }
    }, []);

    const handleLogout = () => {
        localStorage.clear();
        console.log("User logged out");
    };

    const navigate = useNavigate();

    useEffect(() => {
        if (localStorage.getItem('token') === null) {
            navigate('/');
        }
    }, []);

    return (
        <>
            {!displaySidebar && (
                <div>
                    <head>
                        <meta http-equiv="X-UA-Compatible" content="IE=edge" />
                        <meta
                            content="width=device-width, initial-scale=1.0, shrink-to-fit=no"
                            name="viewport"
                        />
                        <link rel="stylesheet" href="../assets/css/plugins.min.css" />
                        <link rel="stylesheet" href="../assets/css/kaiadmin.min.css" />
                    </head>

                    <div className="sidebar" data-background-color="dark">
                        <div className="sidebar-logo">
                            <div className="logo-header" data-background-color="dark">
                                <Link to="/dashboard" className="logo">
                                    <h1 style={{ color: '#60a5fa' }}>E-books</h1>
                                </Link>
                                <div className="nav-toggle">
                                    <button className="btn btn-toggle toggle-sidebar">
                                        <i className="gg-menu-right"></i>
                                    </button>
                                    <button className="btn btn-toggle sidenav-toggler">
                                        <i className="gg-menu-left"></i>
                                    </button>
                                </div>
                                <button className="topbar-toggler more">
                                    <i className="gg-more-vertical-alt"></i>
                                </button>
                            </div>
                        </div>
                        <div className="sidebar-wrapper scrollbar scrollbar-inner">
                            <div className="sidebar-content">
                                <ul className="nav nav-secondary">
                                    <li className="nav-item active">
                                        <Link to="/dashboard" style={{ display: 'flex', alignItems: 'center', padding: '10px 15px', textDecoration: 'none', color: '#fff' }}>
                                            <FontAwesomeIcon icon={faTachometerAlt} style={{ marginRight: '10px' }} />
                                            <p style={{ margin: 0 }}>Dashboard</p>
                                        </Link>
                                    </li>

                                    {/* Admin Panel – visible only if isAdmin */}
                                    {isAdmin && (
                                        <li className="nav-item">
                                            <Link to="/admin" style={{ display: 'flex', alignItems: 'center', padding: '10px 15px', textDecoration: 'none', color: '#fff' }}>
                                                <FontAwesomeIcon icon={faUserCog} style={{ marginRight: '10px' }} />
                                                <p style={{ margin: 0 }}>Admin Panel</p>
                                            </Link>
                                        </li>
                                    )}

                                    <li className="nav-item">
                                        <Link
                                            type="button"
                                            onClick={() => toggleDropdown("account")}
                                            className={`collapsed ${openDropdown === "account" ? "show" : ""} nav-link`}
                                            style={{ display: 'flex', alignItems: 'center', padding: '10px 15px', textDecoration: 'none', color: '#fff' }}
                                        >
                                            <FontAwesomeIcon icon={faWallet} style={{ marginRight: '10px' }} />
                                            <p style={{ margin: 0 }}>Account</p>
                                            <span className="caret"></span>
                                        </Link>
                                        <div className={`collapse ${openDropdown === "account" ? "show" : ""}`} id="account">
                                            <ul className="nav nav-collapse">
                                                <li>
                                                    <Link to="/transactions" style={{ textDecoration: 'none', color: '#fff' }}>
                                                        <span className="sub-item">Withdrawal History</span>
                                                    </Link>
                                                </li>
                                                <li>
                                                    <Link to="/cashout" style={{ textDecoration: 'none', color: '#fff' }}>
                                                        <span className="sub-item">Cash Out</span>
                                                    </Link>
                                                </li>
                                                <li>
                                                    <Link to="/pendingbalance" style={{ textDecoration: 'none', color: '#fff' }}>
                                                        <span className="sub-item">Pending Balances</span>
                                                    </Link>
                                                </li>
                                            </ul>
                                        </div>
                                    </li>

                                    <li className="nav-item">
                                        <Link
                                            type="button"
                                            onClick={() => toggleDropdown("settings")}
                                            className={`collapsed ${openDropdown === "settings" ? "show" : ""} nav-link`}
                                            style={{ display: 'flex', alignItems: 'center', padding: '10px 15px', textDecoration: 'none', color: '#fff' }}
                                        >
                                            <FontAwesomeIcon icon={faTools} style={{ marginRight: '10px' }} />
                                            <p style={{ margin: 0 }}>Settings</p>
                                            <span className="caret"></span>
                                        </Link>
                                        <div className={`collapse ${openDropdown === "settings" ? "show" : ""}`} id="settings">
                                            <ul className="nav nav-collapse">
                                                <li>
                                                    <Link to="/changepassword" style={{ textDecoration: 'none', color: '#fff' }}>
                                                        <span className="sub-item">Change Password</span>
                                                    </Link>
                                                </li>
                                            </ul>
                                        </div>
                                    </li>

                                    <li className="nav-item">
                                        <Link to="/about" style={{ display: 'flex', alignItems: 'center', padding: '10px 15px', textDecoration: 'none', color: '#fff' }}>
                                            <FontAwesomeIcon icon={faInfo} style={{ marginRight: '10px' }} />
                                            <p style={{ margin: 0 }}>About</p>
                                        </Link>
                                    </li>

                                    <li className="nav-item" style={{ marginTop: 'auto' }}>
                                        <Link
                                            to="/"
                                            onClick={handleLogout}
                                            className="nav-link"
                                            style={{ display: 'flex', alignItems: 'center', padding: '10px 15px', textDecoration: 'none', color: '#fff' }}
                                        >
                                            <FontAwesomeIcon icon={faSignOutAlt} style={{ marginRight: '10px' }} />
                                            <p style={{ margin: 0 }}>Logout</p>
                                        </Link>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            )}
            {displaySidebar && (
                <div className="nav_open">
                    <head>
                        <meta http-equiv="X-UA-Compatible" content="IE=edge" />
                        <meta
                            content="width=device-width, initial-scale=1.0, shrink-to-fit=no"
                            name="viewport"
                        />
                        <link rel="stylesheet" href="../assets/css/plugins.min.css" />
                        <link rel="stylesheet" href="../assets/css/kaiadmin.min.css" />
                    </head>

                    <div className="sidebar" data-background-color="dark">
                        <div className="sidebar-logo">
                            <div className="logo-header" data-background-color="dark">
                                <Link to="/dashboard" className="logo">
                                    <h1 style={{ color: '#60a5fa' }}>E-books</h1>
                                </Link>
                                <div className="nav-toggle">
                                    <button className="btn btn-toggle toggle-sidebar">
                                        <i className="gg-menu-right"></i>
                                    </button>
                                    <button className="btn btn-toggle sidenav-toggler">
                                        <i className="gg-menu-left"></i>
                                    </button>
                                </div>
                                <button className="topbar-toggler more">
                                    <i className="gg-more-vertical-alt"></i>
                                </button>
                            </div>
                        </div>
                        <div className="sidebar-wrapper scrollbar scrollbar-inner">
                            <div className="sidebar-content">
                                <ul className="nav nav-secondary">
                                    <li className="nav-item active">
                                        <Link to="/dashboard" style={{ display: 'flex', alignItems: 'center', padding: '10px 15px', textDecoration: 'none', color: '#fff' }}>
                                            <FontAwesomeIcon icon={faTachometerAlt} style={{ marginRight: '10px' }} />
                                            <p style={{ margin: 0 }}>Dashboard</p>
                                        </Link>
                                    </li>

                                    {/* Admin Panel – visible only if isAdmin */}
                                    {isAdmin && (
                                        <li className="nav-item">
                                            <Link to="/admin" style={{ display: 'flex', alignItems: 'center', padding: '10px 15px', textDecoration: 'none', color: '#fff' }}>
                                                <FontAwesomeIcon icon={faUserCog} style={{ marginRight: '10px' }} />
                                                <p style={{ margin: 0 }}>Admin Panel</p>
                                            </Link>
                                        </li>
                                    )}

                                    <li className="nav-item">
                                        <Link
                                            type="button"
                                            onClick={() => toggleDropdown("account")}
                                            className={`collapsed ${openDropdown === "account" ? "show" : ""} nav-link`}
                                            style={{ display: 'flex', alignItems: 'center', padding: '10px 15px', textDecoration: 'none', color: '#fff' }}
                                        >
                                            <FontAwesomeIcon icon={faWallet} style={{ marginRight: '10px' }} />
                                            <p style={{ margin: 0 }}>Account</p>
                                            <span className="caret"></span>
                                        </Link>
                                        <div className={`collapse ${openDropdown === "account" ? "show" : ""}`} id="account">
                                            <ul className="nav nav-collapse">
                                                <li>
                                                    <Link to="/transactions" style={{ textDecoration: 'none', color: '#fff' }}>
                                                        <span className="sub-item">Withdrawal History</span>
                                                    </Link>
                                                </li>
                                                <li>
                                                    <Link to="/cashout" style={{ textDecoration: 'none', color: '#fff' }}>
                                                        <span className="sub-item">Cash Out</span>
                                                    </Link>
                                                </li>
                                                <li>
                                                    <Link to="/pendingbalance" style={{ textDecoration: 'none', color: '#fff' }}>
                                                        <span className="sub-item">Pending Balances</span>
                                                    </Link>
                                                </li>
                                            </ul>
                                        </div>
                                    </li>

                                    <li className="nav-item">
                                        <Link
                                            type="button"
                                            onClick={() => toggleDropdown("settings")}
                                            className={`collapsed ${openDropdown === "settings" ? "show" : ""} nav-link`}
                                            style={{ display: 'flex', alignItems: 'center', padding: '10px 15px', textDecoration: 'none', color: '#fff' }}
                                        >
                                            <FontAwesomeIcon icon={faTools} style={{ marginRight: '10px' }} />
                                            <p style={{ margin: 0 }}>Settings</p>
                                            <span className="caret"></span>
                                        </Link>
                                        <div className={`collapse ${openDropdown === "settings" ? "show" : ""}`} id="settings">
                                            <ul className="nav nav-collapse">
                                                <li>
                                                    <Link to="/changepassword" style={{ textDecoration: 'none', color: '#fff' }}>
                                                        <span className="sub-item">Change Password</span>
                                                    </Link>
                                                </li>
                                            </ul>
                                        </div>
                                    </li>

                                    <li className="nav-item">
                                        <Link to="/about" style={{ display: 'flex', alignItems: 'center', padding: '10px 15px', textDecoration: 'none', color: '#fff' }}>
                                            <FontAwesomeIcon icon={faInfo} style={{ marginRight: '10px' }} />
                                            <p style={{ margin: 0 }}>About</p>
                                        </Link>
                                    </li>

                                    <li className="nav-item" style={{ marginTop: 'auto' }}>
                                        <Link
                                            to="/"
                                            onClick={handleLogout}
                                            className="nav-link"
                                            style={{ display: 'flex', alignItems: 'center', padding: '10px 15px', textDecoration: 'none', color: '#fff' }}
                                        >
                                            <FontAwesomeIcon icon={faSignOutAlt} style={{ marginRight: '10px' }} />
                                            <p style={{ margin: 0 }}>Logout</p>
                                        </Link>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default Sidebar;